import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

if ((window as any).SENTRY_CONFIG) {
    Sentry.init({
        ...(window as any).SENTRY_CONFIG,
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}
